import { Component, Input } from '@angular/core';
import {SafeUrl} from "@angular/platform-browser";

@Component({
    selector: 'app-signature-preview',
    templateUrl: './signature-preview.component.html',
    styleUrls: ['./signature-preview.component.scss'],
    standalone: false
})
export class SignaturePreviewComponent {

  @Input() signatureImage: SafeUrl | null;

}
